import {
  PLUGIN_OPERATIONS,
  DIRECT_PLUGIN,
} from "@openedx/frontend-plugin-framework";
import CourseAppTranslation from "@edx/course-app-translation-plugin";
import { DatadogLoggingService } from '@edx/frontend-logging';
import { Hyperlink, Image } from '@openedx/paragon';

// Load environment variables from .env file
const config = {
  ...process.env,
  AI_TRANSLATIONS_URL: 'https://ai-translations.stage.edx.org',
  loggingService: DatadogLoggingService,
  pluginSlots: {
    additional_course_plugin: {
      plugins: [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: "whole-course-translation-plugin",
            type: DIRECT_PLUGIN,
            priority: 1,
            RenderWidget: CourseAppTranslation,
          },
        },
      ],
    },
    "org.openedx.frontend.layout.studio_footer_logo.v1": {
      keepDefault: false,
      plugins: [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'studio_footer_logo_slot',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              return (
              <>
                <Hyperlink destination="https://stage.edx.org/" className="float-right">
                    <Image
                      width="120px"
                      alt="Powered by Open edX"
                      src="https://edx-cdn.org/v3/stage/logo.svg"
                    />
                </Hyperlink>
              </>
            )
            },
          },
        },
      ],
    },
  },
};

export default config;
